/**
 * Where the full, public scoreboard lives.
 *
 * The member app deliberately shows a competitor only their own category. The
 * other categories, and the screen a gym puts on a monitor, are on the public
 * site, which needs no account.
 *
 * Mirrors `memberAppUrl` in apps/web: derived from VITE_APP_ENV, which the
 * deploy workflow already sets per branch, so a staging page never sends anyone
 * to production. VITE_WEB_URL overrides it for local work.
 */
const HOSTS = {
  production: 'https://structuralclimbing.com',
  staging: 'https://staging.structural-web.pages.dev',
} as const

export function publicSiteUrl(path = ''): string {
  const override = import.meta.env.VITE_WEB_URL as string | undefined
  const env = import.meta.env.VITE_APP_ENV as string | undefined
  const base = override || (env === 'production' ? HOSTS.production : HOSTS.staging)
  return `${base.replace(/\/$/, '')}${path}`
}
